export default [
  {
    path: '/iap-product',
    component: () => import('./views/Index'),
    name: 'iap-product',
    redirect: { name: 'iap-product-list' },
    children: [
      {
        path: '',
        name: 'iap-product-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'goga-earn',
        },
      },
      {
        path: ':id',
        name: 'iap-product-detail',
        component: () => import('./views/Detail'),
        meta: {
          resource: 'goga-earn',
        },
      },
    ],
  },
]
